import { Accordion, Col, Row, Stack } from 'react-bootstrap';
import { PiForkKnifeFill } from 'react-icons/pi';
import { Link } from 'react-router-dom';
import { Course } from '../../../../types/course.type';
import { Lesson } from '../../../../types/lesson.type';
import { getLessonSessionTimeDisplay } from '../../../../utils/dateUtils';
import SafeHTMLDisplay from '../../../common/SafeHTMLDisplay';
import {parse} from "date-fns";

function getLessonDate(lesson: Lesson): string {
  // lesson.date is a date-only string (yyyy-MM-dd). Parse as a local calendar
  // date so it doesn't shift a day in US timezones (new Date(str) is UTC midnight,
  // which toLocaleDateString then renders as the previous day behind UTC).
  const dateOnly = lesson.date.includes('T') ? lesson.date.split('T')[0] : lesson.date;
  const date = parse(dateOnly, 'yyyy-MM-dd', new Date());
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric'
  });
}

interface CourseDetailsAccordionProps {
  course: Course;
}

const CourseDetailsAccordion: React.FC<CourseDetailsAccordionProps> = ({ course }) => {
  return (
    <Row className="mt-4">
      <Col>
        <Accordion
            defaultActiveKey={['0', '1', '2', '3']}
            className="course-details-accordion"
        >
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <span className="h4 text-capitalize text-info fw-bold mb-0">
                Important Information you KNEAD to know
              </span>
            </Accordion.Header>
            <Accordion.Body>
              <div className="course-details-rich-text">
                <SafeHTMLDisplay htmlContent={course.description} />
              </div>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <span className="h4 text-capitalize text-info fw-bold mb-0">JUICY Theme Details</span>
            </Accordion.Header>
            <Accordion.Body>
              <p>
                <span className="accordion-sub">Theme</span>
                <br />
                <span className="fw-bold">{course.theme.name}</span>
              </p>
              <div className="course-details-rich-text">
                <SafeHTMLDisplay htmlContent={course.theme.details} />
              </div>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <span className="h4 text-capitalize text-info fw-bold mb-0">Recipes</span>
            </Accordion.Header>
            <Accordion.Body>
              <p className="accordion-sub">Recipes</p>
              {course.lessons.map((lesson, index) => (
                <div key={`recipe-lesson-${index}`}>
                  {lesson.lesson_plans.map((plan, idx) => (
                    <Stack
                      key={idx}
                      gap={1}
                      direction="horizontal"
                    >
                      <PiForkKnifeFill style={{ color: '#000', fontSize: '18px' }} />
                      <Link
                        key={`recipe-lesson-plan-${idx}`}
                        to={`/lesson-plans/${plan.slug}`}
                        className="text-capitalize"
                        style={{ textDecoration: 'none', color: '#6098B8' }}
                      >
                        {plan.name}
                      </Link>
                    </Stack>
                  ))}
                </div>
              ))}
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>
              <span className="h4 text-capitalize text-info fw-bold mb-0">Class Schedule</span>
            </Accordion.Header>
            <Accordion.Body>
              <p className="accordion-sub">Session Schedule & Recipes</p>
              {course.lessons.map((lesson, index) => (
                <p key={`schedule-lesson-${index}`}>
                  <span className="fw-bold text-uppercase">{getLessonDate(lesson)} </span>
                  <span>({getLessonSessionTimeDisplay(lesson, course)})</span>
                  <br />
                  {lesson.lesson_plans.map((plan, idx) => (
                    <Link
                      key={`schedule-lesson-plan-${index}-${idx}`}
                      to={`/lesson-plans/${plan.slug}`}
                      className="text-capitalize"
                      style={{ textDecoration: 'none', color: '#6098B8', display: 'block' }}
                    >
                      {plan.name}
                    </Link>
                  ))}
                </p>
              ))}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Col>
    </Row>
  );
};
export default CourseDetailsAccordion;
